import { useTranslation } from 'react-i18next';
import { SearchBox } from '../../../inputs';
import { useDataGridContext } from '../../data-grid-context';

export function GridToolbarSearch() {
  const { t } = useTranslation();

  const { searchInputRef, onSearchTermChange } = useDataGridContext();

  return (
    <SearchBox
      inputRef={searchInputRef}
      placeholder={t('inputs.listBox.search')}
      onSearchTermChange={onSearchTermChange}
      data-testid='grid-search'
    />
  );
}
